// extracted by mini-css-extract-plugin
export var arrows = "_82-6";
export var decrementer = "_82-a";
export var disabled = "_82-4";
export var error = "_82-1";
export var hiddenText = "_82-b";
export var incrementer = "_82-9";
export var input = "_82-8";
export var inputWrapper = "_82-0";
export var leadingIcon = "_82-c";
export var readonly = "_82-3";
export var regular = "_82-7";
export var small = "_82-5";
export var warning = "_82-2";